module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.84604","quantity":0.00846},{"color":"#9dc4b5","label":" 0.84604- 0.84604","quantity":0.00846},{"color":"#e6efc3","label":" 0.84604- 1.11564","quantity":0.01116},{"color":"#ffe89e","label":" 1.11564- 1.6789","quantity":0.01679},{"color":"#f5af7f","label":" 1.6789- 2.67818","quantity":0.02678},{"color":"#ed6d32","label":" 2.67818- 10.30437","quantity":0.10304}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_70_return_10.json
// module id = gsg2
// module chunks = 171